import { GET_EMBEDED_TREE, GET_TREE_NAMES } from "../../queries";
import { MATCH_ANY_PARAMETERS } from 'wildcard-mock-link';
import { getTreeName } from "./state-tree";
const treeExample = {
  Initial: 'Initial',
  Control_affecté: 'Control affecté',
  Control_OK: 'Control OK',
  Control_KO: 'Control KO',
  Valide: 'Valide'
};
export default [{
  request: {
    query: GET_TREE_NAMES,
    variables: MATCH_ANY_PARAMETERS
  },
  result: {
    data: {
      tree_readMapNames: treeExample
    }
  }
}, {
  request: {
    query: GET_EMBEDED_TREE,
    variables: MATCH_ANY_PARAMETERS
  },
  result: variables => {
    window.status = getTreeName(variables === null || variables === void 0 ? void 0 : variables.treeId);
    return {
      data: {
        tree_read: {
          treelevel1: window.status,
          treelevel2: undefined,
          treelevel3: undefined,
          treelevel4: undefined
        }
      }
    };
  }
}];